function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(-1 0 0 1 7 0)",
  width: 7,
  height: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(-1 0 0 1 7 0)",
  y: 9,
  width: 7,
  height: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(-1 0 0 1 25 0)",
  x: 9,
  width: 7,
  height: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(-1 0 0 1 25 0)",
  x: 9,
  y: 9,
  width: 7,
  height: 7,
  rx: 2
}));

function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8Zz4KICAgICAgICA8cmVjdCBmaWxsPSJjdXJyZW50Q29sb3IiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuNTAwMDAwLCAzLjUwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMy41MDAwMDAsIC0zLjUwMDAwMCkgIiB4PSIwIiB5PSIwIiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiByeD0iMiI+PC9yZWN0PgogICAgICAgIDxyZWN0IGZpbGw9ImN1cnJlbnRDb2xvciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy41MDAwMDAsIDEyLjUwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMy41MDAwMDAsIC0xMi41MDAwMDApICIgeD0iMCIgeT0iOSIgd2lkdGg9IjciIGhlaWdodD0iNyIgcng9IjIiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSJjdXJyZW50Q29sb3IiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMy41MDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMuNTAwMDAwKSAiIHg9IjkiIHk9IjAiIHdpZHRoPSI3IiBoZWlnaHQ9IjciIHJ4PSIyIj48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iY3VycmVudENvbG9yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi41MDAwMDAsIDEyLjUwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTIuNTAwMDAwLCAtMTIuNTAwMDAwKSAiIHg9IjkiIHk9IjkiIHdpZHRoPSI3IiBoZWlnaHQ9IjciIHJ4PSIyIj48L3JlY3Q+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgGrid as ReactComponent };